module.exports = __webpack_public_path__ + "static/media/08fa-standard.73bc0588.jpg";